export const REQUIRED_ROLES= [
      'cpit-userverwaltung-manage-users',
      'cpit-userverwaltung-manage-licenses',
      'cpit-userverwaltung-manage-vermittlers',
      'cpit-userverwaltung-manage-usergroups',
    ];